import { render, staticRenderFns } from "./SendQuotePage.vue?vue&type=template&id=07457290&scoped=true"
import script from "./SendQuotePage.vue?vue&type=script&lang=js"
export * from "./SendQuotePage.vue?vue&type=script&lang=js"
import style0 from "./SendQuotePage.vue?vue&type=style&index=0&id=07457290&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07457290",
  null
  
)

export default component.exports